var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVideoPlayer = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 46.314,
  height: 46.314,
  x: 0.692,
  y: 0.509,
  fill: "#fff",
  fillOpacity: 0.4,
  rx: 23.157
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 46.314,
  height: 46.314,
  x: 0.692,
  y: 0.509,
  stroke: "#fff",
  strokeWidth: 0.612,
  rx: 23.157
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2.075,
  d: "M15.548 23.666v-3.694c0-4.579 3.251-6.46 7.222-4.164l3.195 1.854 3.196 1.854c3.97 2.296 3.97 6.046 0 8.342l-3.196 1.854-3.195 1.854c-3.97 2.255-7.222.387-7.222-4.206z"
})));
export default SvgVideoPlayer;